import './axios';
import './vuelidate';
import './uiplugins';
import './wait';
import './api_query';
import './clipboard';
import './cookie';